import firebase from 'firebase'
import Firestore from 'firebase/firestore'

var config = {
  apiKey: "AIzaSyB2o9EnTc6ETFPxh_FE98eCT_AlqMCbnZU",
  authDomain: "zwerverhunt-69c09.firebaseapp.com",
  databaseURL: "https://zwerverhunt-69c09.firebaseio.com",
  projectId: "zwerverhunt-69c09",
  storageBucket: "zwerverhunt-69c09.appspot.com",
  messagingSenderId: "142801624378",
  timestampsInSnapshots: true
};
firebase.initializeApp(config);

export default firebase;


// WEBPACK FOOTER //
// ./src/services/firebase.js